import { useQuery } from '@tanstack/react-query';
import type { PartnerTenant } from '@shipium-corp/shipium-ts-types';
import { useQueryCreator } from '~/hooks/useQueryCreator';
import { partnerManagementService } from '~/services';

export interface TenantsQueryResult {
  tenantsArray: PartnerTenant[];
  tenantsRecord: Record<string, PartnerTenant>;
}

export const useTenantsQuery = () => {
  const queryOptions = useQueryCreator(partnerManagementService.tenants.search, {
    args: [{}],
  });

  return useQuery({
    ...queryOptions,
    select: (data: PartnerTenant[]): TenantsQueryResult => ({
      tenantsArray: data.sort((a, b) => (a.name || '').localeCompare(b.name || '')),
      tenantsRecord: data.reduce(
        (acc, tenant) => {
          if (tenant.tenantId) {
            acc[tenant.tenantId] = tenant;
          }
          return acc;
        },
        {} as Record<string, PartnerTenant>,
      ),
    }),
  });
};
